import { FunctionBrick, registerBrick, Auth } from 'olympe'

export default class GetTokenPayloadDetails extends FunctionBrick {
    /**
     * Executed every time an input () gets updated.
     * Note that this method will _not_ be executed if an input value is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function(string)} setDisplayName
     * @param {function(string)} setEMailAddress
     * @param {function(string)} setGivenName
     * @param {function(string)} setSurname
     */
    onUpdate(context, inputs, [setDisplayName, setEMailAddress, setGivenName, setSurname]) {
        // db.transaction("Olympe_AUTH").objectStore("main").get(0).onsuccess = function(event) {
        //     result = console.log("Your value is:" + event.target.result.value);
        // }
        // setDisplayName(result);
    }
}

registerBrick('017a571a1cdc6c45c489', GetTokenPayloadDetails)
